import React, { useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import AdminService from "../../../services/AdminService"; // Import your actual service
import { VerifyUserCard } from "./VerifyUser";
import { snakeToSpaced } from "../../helpers/stringHelpers";

const StakingMaturedTable = ({ maturedList, maturedListLoading }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = useMemo(() => {
    return Math.ceil((maturedList?.length || 0) / itemsPerPage);
  }, [maturedList, itemsPerPage]);

  const currentData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return maturedList?.slice(startIndex, endIndex);
  }, [maturedList, currentPage, itemsPerPage]);

  return (
    <div className="w-full mt-6">
      <VerifyUserCard title={"Matured Staking"}>
        {maturedListLoading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="overflow-x-scroll">
              <table className="table border-no tbl-btn short-one">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Token Stake Amount</th>
                    <th>APR</th>
                    <th>Maturity Date</th>
                    <th>User ID</th>
                    <th>VIP Status</th>
                    <th>Start Date</th>
                    <th>Duration</th>
                    <th>Token Received</th>
                    <th>Penalty Percentage</th>
                    <th>Token Return</th>
                    <th>Token Bonus Sent</th>
                    <th>User Wallet Address</th>
                    <th>Maturity Token Bonus</th>
                    <th>Token Bonus Hash</th>
                    <th>Time Added</th>
                    <th>Time Start</th>
                    <th>Time Mature</th>
                    <th>Time Unstake</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData?.map((record, index) => (
                    <tr
                      className={`border-y trans-td-list dark:!text-white ${index % 2 === 0 ? "bg-gray-900" : ""}`}
                      key={record.hash}
                    >
                      <td>{record.type}</td>
                      <td>
                        {Intl.NumberFormat("en-US").format(
                          Number(record.token_stake_amount),
                        )}
                      </td>
                      <td>{(record.apr * 100).toFixed(2)}%</td>
                      <td>
                        {new Date(
                          record.maturity_datetime,
                        ).toLocaleDateString()}
                      </td>
                      <td>{record.user_id}</td>
                      <td>{record.is_vip}</td>
                      <td>
                        {new Date(record.start_datetime).toLocaleDateString()}
                      </td>
                      <td>{`${record.duration_amount} ${record.duration_type}`}</td>
                      <td>
                        {Intl.NumberFormat("en-US").format(
                          Number(record.token_received),
                        )}
                      </td>
                      <td>{(record.penalty_perc * 100).toFixed(2)}%</td>
                      <td>
                        {Intl.NumberFormat("en-US").format(
                          Number(record.token_return),
                        )}
                      </td>
                      <td>
                        {Intl.NumberFormat("en-US").format(
                          Number(record.token_bonus_sent),
                        )}
                      </td>
                      <td>{record.user_wallet_address}</td>
                      <td>
                        {Intl.NumberFormat("en-US").format(
                          Number(record.maturity_token_bonus),
                        )}
                      </td>
                      <td>{record.token_bonus_hash}</td>
                      <td>
                        {new Date(record.time_added * 1000).toLocaleString()}
                      </td>
                      <td>
                        {new Date(record.time_start * 1000).toLocaleString()}
                      </td>
                      <td>
                        {new Date(record.time_mature * 1000).toLocaleString()}
                      </td>
                      <td>
                        {new Date(record.time_unstake * 1000).toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="table-pagenation mb-3">
              <p className="ms-0">
                Showing{" "}
                <span>
                  {(currentPage - 1) * itemsPerPage + 1}-
                  {Math.min(currentPage * itemsPerPage, maturedList?.length)}
                </span>{" "}
                from <span>{maturedList?.length}</span> data
              </p>
              <nav>
                <ul className="pagination pagination-gutter pagination-primary no-bg">
                  <li className="page-item page-indicator">
                    <button
                      className="page-link"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(currentPage - 1)}
                    >
                      <i className="fa-solid fa-angle-left"></i>
                    </button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <li
                      key={i + 1}
                      className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                  <li className="page-item page-indicator">
                    <button
                      className="page-link"
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      <i className="fa-solid fa-angle-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </>
        )}
      </VerifyUserCard>
    </div>
  );
};

export default StakingMaturedTable;
